import styles from './CustomTooltip.module.css';

interface ExtendedTooltipProps {
	active?: boolean;
	payload?: Array<{
		name?: string;
		value?: number | string;
		color?: string;
		stroke?: string;
		payload: {
			name?: string;
			value?: number;
			day?: string;
			[key: string]: any;
		};
	}>;
	subtitle: string;
	variant?: 'donut' | 'line';
	coordinate?: { x: number; y: number };
	viewBox?: { width: number; height: number };
	chartWidth?: number;
}

export const CustomTooltip = ({
	active,
	payload,
	subtitle,
	variant = 'donut',
	coordinate,
	chartWidth,
}: ExtendedTooltipProps) => {
	if (active && payload?.length) {
		const isRightSide = chartWidth && coordinate && coordinate.x > chartWidth * 0.6;

		const tooltipColor = variant === 'donut' ? 'var(--primary-dark)' : 'var(--bg-page)';

		const containerStyle: React.CSSProperties = {
			transform: isRightSide ? 'translate(-5%, -125%)' : 'translate(-50%, -125%)',
		};

		const contentStyle: React.CSSProperties = {
			backgroundColor: tooltipColor,
		};

		const arrowStyle: React.CSSProperties = {
			margin: isRightSide ? '0 1rem 0 auto' : '0 auto',
			borderTopColor: tooltipColor,
		};

		if (variant === 'line') {
			return (
				<div className={styles.tooltipContainer} style={containerStyle}>
					<div className={styles.tooltipContent} style={contentStyle}>
						<div className={styles.tooltipList}>
							{payload.map((entry: any, index: number) => (
								<div key={entry.name || index} className={styles.tooltipItem}>
									<div className={styles.tooltipItemLabel}>
										<div
											className={styles.tooltipDot}
											style={{ backgroundColor: entry.stroke || entry.color }}
										/>
										<span>{entry.name}</span>
									</div>
									<span className={styles.tooltipItemValue}>{entry.value}</span>
								</div>
							))}
						</div>
					</div>
					<div className={styles.tooltipArrow} style={arrowStyle} />
				</div>
			);
		}

		const data = payload[0].payload;
		return (
			<div className={styles.tooltipContainer} style={containerStyle}>
				<div className={styles.tooltipContent} style={contentStyle}>
					<span className={styles.tooltipTitle}>{data.name}</span>
					<span className={styles.tooltipDate}>{subtitle}</span>
					<span className={styles.tooltipValue}>{data.value} registros</span>
				</div>
				<div className={styles.tooltipArrow} style={arrowStyle} />
			</div>
		);
	}
	return null;
};
